import { render, staticRenderFns } from "./MainHowto.vue?vue&type=template&id=23a2bad3&scoped=true&lang=html"
import script from "./MainHowto.vue?vue&type=script&lang=js"
export * from "./MainHowto.vue?vue&type=script&lang=js"
import style0 from "./MainHowto.vue?vue&type=style&index=0&id=23a2bad3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a2bad3",
  null
  
)

export default component.exports